/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
export default function idx(input: any, accessor: any): any {
  try {
    return accessor(input);
  } catch (error) {
    // yum
  }
}
